<template>
  <v-container>
    <div style="max-width: 600px">
      <h1>
        <v-label>{{ activationMsg }}</v-label>
      </h1>
      <h1>
        <v-icon>fa-id-card</v-icon>
        <span> Edit profile</span>
      </h1>
      <v-text-field
        v-model="fullname"
        label="Name"
        outlined
        prepend-inner-icon="mdi-account-box"
        readonly
        shaped
      ></v-text-field>
      <p>
        <v-form>
          <v-row justify="space-around" align="baseline">
            <v-btn
              rounded
              color="primary"
              @click="eyevalue = !eyevalue"
              v-if="eyevalue"
              >Show Access Code
              <v-icon small right>mdi-eye</v-icon>
            </v-btn>
            <v-btn
              rounded
              color="primary"
              @click="eyevalue = !eyevalue"
              v-if="!eyevalue"
              >Hide Access Code
              <v-icon small right>mdi-eye-off</v-icon>
            </v-btn>
            <div class="pt-4">
              <v-text-field
                background-color="white"
                v-model="curac"
                outlined
                prepend-inner-icon="mdi-lock-question"
                label="Your Current Access Code"
                :append-icon="eyevalue ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="() => (eyevalue = !eyevalue)"
                :type="eyevalue ? 'password' : 'text'"
                style="max-width: 300px"
                readonly
              ></v-text-field>
            </div>
          </v-row>
        </v-form>
      </p>
      <v-alert type="success" :value="isAlertVisible">{{
        statusResultMsg
      }}</v-alert>
      <v-alert type="error" :value="isWarningAlertVisible">{{
        statusResultMsg
      }}</v-alert>
      <v-expansion-panels focusable>
        <v-expansion-panel>
          <v-expansion-panel-header
            >Change Access Code</v-expansion-panel-header
          >
          <v-divider></v-divider>
          <v-expansion-panel-content>
            <v-form v-model="isValidNewAC">
              Current access code:
              <v-label>{{ curac }}</v-label>
              <v-text-field
                v-model="ac"
                outlined
                required
                prepend-inner-icon="mdi-lock-question"
                placeholder="New Access Code"
                :rules="acRules"
                hint="Enter new access code"
                :append-icon="eyevalue ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="() => (eyevalue = !eyevalue)"
                :type="eyevalue ? 'password' : 'text'"
              ></v-text-field>
              <v-col>
                <v-btn
                  :disabled="!isValidNewAC"
                  color="primary"
                  @click="submitac"
                  :class="`d-flex justify-space-around mb-6`"
                  >Save new access code</v-btn
                >
              </v-col>
            </v-form>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>Change Email</v-expansion-panel-header>
          <v-divider></v-divider>
          <v-expansion-panel-content>
            <v-form v-model="isValidNewEmail">
              Current E-mail:
              <v-label>{{ curemail }}</v-label>
              <v-text-field
                v-model="email"
                outlined
                prepend-inner-icon="mdi-email"
                placeholder="New E-mail"
                required
                :rules="emailRules"
              ></v-text-field>
              <v-col>
                <v-btn
                  :disabled="!isValidNewEmail"
                  color="primary"
                  @click="submitemail"
                  :class="`d-flex justify-space-around mb-6`"
                  >Save new email</v-btn
                >
              </v-col>
            </v-form>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>Change Mobile</v-expansion-panel-header>
          <v-divider></v-divider>
          <v-expansion-panel-content>
            <v-form v-model="isValidNewMobile">
              Current Mobile:
              <v-label>{{ curmobile }}</v-label>
              <v-text-field
                v-model="mobile"
                outlined
                prepend-inner-icon="mdi-cellphone-android"
                placeholder="New Mobile"
                required
                :rules="mobileRules"
              ></v-text-field>
              <v-col>
                <v-btn
                  :disabled="!isValidNewNation"
                  color="primary"
                  @click="submitmobile"
                  :class="`d-flex justify-space-around mb-6`"
                  >Save new mobile</v-btn
                >
              </v-col>
            </v-form>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header
            >Change Nationality</v-expansion-panel-header
          >
          <v-divider></v-divider>
          <v-expansion-panel-content>
            <Flags
              v-bind="post"
              @valueChangedMethodInComponent="setValueMethodInView"
            ></Flags>
            <v-col>
              <v-btn
                :disabled="!isValidNewNation"
                color="primary"
                @click="submitnation"
                :class="`d-flex justify-space-around mb-6`"
                >Save new nation</v-btn
              >
            </v-col>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header
            >Notification Subscriptions</v-expansion-panel-header
          >
          <v-divider></v-divider>
          <v-expansion-panel-content>
            <h3>Get notification when an event/box is opened.</h3>

            <h4 v-if="notifyenabled">
              <strong style="color: green"
                >Notification Service is Activated.</strong
              >
            </h4>
            <h4 v-else>
              <strong style="color: red"
                >Notification Service is Not Activated!</strong
              >
            </h4>
            <v-btn color="primary" rounded @click="dialog = true" small>
              What is this? Go to help
              <v-icon small right>fa-question-circle</v-icon>
            </v-btn>
            <v-alert color="blue" :value="isInfoVisible" outlined>{{
              info
            }}</v-alert>
            <v-card>
              <v-card-title>
                Notifications
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search event"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="notifysubs"
                :search="search"
                dense
                :loading="loading"
                loading-text="Loading... Please wait"
              >
                <template v-slot:item.NotifyEnabled="{ item }">
                  <v-row>
                    <v-col cols="1">
                      <div v-if="!item.NotifyEnabled">
                        <v-icon
                          small
                          color="red"
                          @click="
                            showInfo(
                              'Notifications is disabled for this box - SMS etc. will not be sent.'
                            )
                          "
                          >fa-lock</v-icon
                        >
                      </div>
                      <div v-if="item.NotifyEnabled">
                        <v-icon
                          small
                          color="green"
                          @click="
                            showInfo('Notifications will be sent on this box.')
                          "
                          >fa-lock-open</v-icon
                        >
                      </div>
                    </v-col>
                  </v-row>
                </template>
                <!-- <template v-slot:item.Sms="{ item }">
                <v-col cols="2">
                    <div v-if="item.SmsEnabled">
                      <v-simple-checkbox v-model="item.Sms" :disabled="!item.SmsEnabled" x-small append-icon="fa-lock-open" color="red"></v-simple-checkbox>
                    </div>
                    <div v-if="!item.SmsEnabled">
                      <v-simple-checkbox v-model="item.Sms" :disabled="!item.SmsEnabled" x-small append-icon="fa-lock" color="green"></v-simple-checkbox>
                    </div>
                </v-col>
              </template>-->
                <template v-slot:item.Sms="{ item }">
                  <v-row>
                    <v-col cols="1">
                      <div v-if="item.SmsEnabled">
                        <v-icon x-small color="green">fa-lock-open</v-icon>
                      </div>
                      <div v-if="!item.SmsEnabled">
                        <v-icon x-small color="red">fa-lock</v-icon>
                      </div>
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox
                        v-model="item.Sms"
                        :disabled="!item.SmsEnabled"
                        dense
                      ></v-simple-checkbox>
                    </v-col>
                  </v-row>
                </template>
                <!-- <template v-slot:item.Messenger="{ item }">
                  <v-row>
                    <v-col cols="1">
                      <div v-if="item.MessengerEnabled">
                        <v-icon x-small color="green" left>fa-lock-open</v-icon>
                      </div>
                      <div v-if="!item.MessengerEnabled">
                        <v-icon x-small color="red">fa-lock</v-icon>
                      </div>
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox
                        v-model="item.Messenger"
                        :disabled="!item.MessengerEnabled"
                        dense
                      ></v-simple-checkbox>
                    </v-col>
                  </v-row>
                </template> -->
                <!-- <template v-slot:item.WhatsApp="{ item }">
                  <v-row>
                    <v-col cols="1">
                      <div v-if="item.WhatsAppEnabled">
                        <v-icon x-small color="green" left>fa-lock-open</v-icon>
                      </div>
                      <div v-if="!item.WhatsAppEnabled">
                        <v-icon x-small color="red">fa-lock</v-icon>
                      </div>
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox
                        v-model="item.WhatsApp"
                        :disabled="!item.WhatsAppEnabled"
                        dense
                      ></v-simple-checkbox>
                    </v-col>
                  </v-row>
                </template> -->
                <template v-slot:item.Mail="{ item }">
                  <v-row>
                    <v-col cols="1">
                      <div v-if="item.MailEnabled">
                        <v-icon x-small color="green" left>fa-lock-open</v-icon>
                      </div>
                      <div v-if="!item.MailEnabled">
                        <v-icon x-small color="red">fa-lock</v-icon>
                      </div>
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox
                        v-model="item.Mail"
                        :disabled="!item.MailEnabled"
                        dense
                      ></v-simple-checkbox>
                    </v-col>
                  </v-row>
                </template>
                <template v-slot:item.EventId="{ item }">
                  <v-btn
                    small
                    color="primary"
                    :disabled="!item.NotifyEnabled"
                    @click="submiteventnotificationsubscription(item)"
                    >Save {{ item.Event }}</v-btn
                  >
                </template>
              </v-data-table>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>Delete account</v-expansion-panel-header>
          <v-divider></v-divider>
          <v-expansion-panel-content>
            Your user account will be erased. Be aware that you can not delete
            it if you are active in a box today.
            <v-col>
              <v-btn color="primary" dark @click.stop="dialog = true"
                >Delete account</v-btn
              >
            </v-col>
            <v-dialog v-model="dialog" max-width="290">
              <v-card>
                <v-card-title class="headline"
                  >Delete your account?</v-card-title
                >

                <v-card-text>Are you absolutely sure?.</v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn color="green darken-1" @click="submitdeleteaccount"
                    >Yes - delete it!</v-btn
                  >

                  <v-btn color="green darken-1" @click="dialog = false"
                    >Cancel</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <ul v-if="errors && errors.length">
        <li v-for="error of errors" :key="error.id" style="color: Red">
          {{ error.message }}
        </li>
      </ul>

      <v-row justify="center">
        <v-dialog
          v-model="dialog"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <!-- <template v-slot:activator="{ on }">
          <v-btn color="primary" dark v-on="on">Open Dialog</v-btn>
        </template>-->
          <v-card>
            <v-toolbar dark color="primary">
              <v-btn icon dark @click="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>Notification Service</v-toolbar-title>
              <v-spacer></v-spacer>
              <!-- <v-toolbar-items>
              <v-btn dark text @click="dialog = false">Save</v-btn>
            </v-toolbar-items>-->
            </v-toolbar>
            <NotificationServiceHelp></NotificationServiceHelp>
          </v-card>
        </v-dialog>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import axios from "axios";
import NotificationServiceHelp from "@/components/help/NotificationServiceHelp.vue";

export default {
  // components: { NotificationServiceHelp },
  name: "RegForm",
  data: () => ({
    fullname: null,
    // firstname: null,
    // lastname: null,
    pk: null,
    ac: null,
    email: null,
    mobile: null,
    mobile2: null,
    mobile2description: null,
    curac: null,
    curemail: null,
    curmobile: null,
    curmobile2: null,
    curmobile2description: null,
    activationMsg: null,
    notifyenabled: null,
    eyevalue: true,
    isValid: true,
    isValidNewAC: true,
    isValidNewEmail: true,
    isValidNewMobile: true,
    isValidNewNation: false,
    isAlertVisible: false,
    isWarningAlertVisible: false,
    isInfoVisible: false,
    info: null,
    select: null,
    profile: [],
    errors: [],
    statuses: [],
    statusResult: Number,
    statusResultMsg: String,
    cancellink: { to: "/" },
    emailRules: [
      (v) => !!v || "Email is required",
      // v => /.+@.+/.test(v) || 'E-mail must be valid'
      (v) =>
        /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
          v
        ) || "E-mail must be valid",
    ],
    mobileRules: [
      (v) => !!v || "Mobile number is required",
      (v) => (v && v.length >= 11) || "Must have more digits.",
      (v) =>
        /([+])\d+/.test(v) ||
        "Mobile number must be valid. Example: +4795142899",
    ],
    acRules: [
      (v) => !!v || "Access code is required.",
      (v) => (v && v.length >= 4) || "Min 4",
      (v) => (v && v.length < 7) || "Max 6",
      (v) =>
        /[A-z]{1,5}[0-9]{1}/.test(v) ||
        "Code must be valid. Only letters og digits, but at least one of each. Example: ab12c3",
    ],
    search: "",
    loading: true,
    headers: [
      { text: "Event", value: "Event" },
      { text: "Description", value: "EventDescription" },
      { text: "Notify", value: "NotifyEnabled" },
      { text: "Sms", value: "Sms" },
      // { text: "Messenger", value: "Messenger" },
      // { text: "WhatsApp", value: "WhatsApp" },
      { text: "Mail", value: "Mail" },
      { text: "Edit", value: "EventId" },
    ],
    notifysubs: [],
    dialog: false,
    post: {
      id: 1,
      text: "Tekst i post",
    },
    // regId: Number,
    text: String,
    showComponent: Boolean,
    compValue: String,
    valueInComponent: String,
  }),

  created() {
    // let uri = window.location.search.substring(1);
    // let params = new URLSearchParams(uri);
    // this.pk = params.get("pk");
    this.pk = this.$route.params.profileKey;
    // console.log(params.get("pk"));
    // this.baseUrl = "http://localhost:3000/dbapi/";
    this.baseUrl = "https://pgapi.azurewebsites.net/dbapi/";
    this.firstname = null;
    this.lastname = null;
    this.email = null;
    this.mobile = null;
    this.statusResult = null;
    this.statusResultMsg = null;
    // this.getnotifysubscriptions();
    // this.isValidNewNation = true;
    this.valueInComponent = "un"; //Placeholder if something bad happens
    // this.post.text = "un";
    this.getprofile();

    this.getnotifysubscriptions();
  },
  methods: {
    submitac() {
      var pid = this.pid;
      var pk = this.pk;
      var ac = this.ac;
      var toSubmit = JSON.stringify({
        pk,
        ac,
      });
      const uri = this.baseUrl + "setnewac/" + pid;

      this.postit(uri, toSubmit);
    },
    submitemail() {
      var pid = this.pid;
      var pk = this.pk;
      var email = this.email;
      var toSubmit = JSON.stringify({
        pk,
        email,
      });
      const uri = this.baseUrl + "setnewemail/" + pid;

      this.postit(uri, toSubmit);
    },
    submitmobile() {
      var pid = this.pid;
      var pk = this.pk;
      var mobile = this.mobile;
      var mobile2 = this.mobile2;
      var mobile2description = this.mobile2description;
      var toSubmit = JSON.stringify({
        pk,
        mobile,
        mobile2,
        mobile2description,
      });
      const uri = this.baseUrl + "setnewmobile/" + pid;

      this.postit(uri, toSubmit);
    },
    submitnation() {
      var pid = this.pid;
      var pk = this.pk;
      var countryCode = this.valueInComponent;
      var toSubmit = JSON.stringify({
        pk,
        countryCode,
      });
      const uri = this.baseUrl + "setnewcountrycode/" + pid;

      this.postit(uri, toSubmit);
    },
    submitdeleteaccount() {
      var pid = this.pid;
      var pk = this.pk;
      var toSubmit = JSON.stringify({
        pk,
      });
      const uri = this.baseUrl + "deletereg/" + pid;
      this.dialog = false;

      this.postit(uri, toSubmit);
    },

    //Uses post here
    getnotifysubscriptions() {
      var pk = this.pk;
      var toSubmit = JSON.stringify({
        pk,
      });
      const uri = this.baseUrl + "getpilotnotificationsubscription";
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      axios
        // .get("http://jsonplaceholder.typicode.com/posts")
        // .get('http://localhost:3000/pilotlist')
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.notifysubs = response.data;
          // console.log(this.notifysubs);
          this.loading = false;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    submiteventnotificationsubscription(item) {
      var pid = this.pid;
      var pk = this.pk;
      // console.log("Save item:", item);
      var eventId = item.EventId;
      var sms = item.Sms;
      var messenger = item.Messenger;
      var whatsapp = item.WhatsApp;
      var mail = item.Mail;
      var toSubmit = JSON.stringify({
        pk,
        eventId,
        sms,
        messenger,
        whatsapp,
        mail,
      });
      const uri = this.baseUrl + "seteventnotificationsubscription/" + pid;
      // console.log(uri);
      // console.log("toSubmit", toSubmit);

      this.postit(uri, toSubmit);
    },

    getprofile() {
      var pk = this.pk;
      var toSubmit = JSON.stringify({
        pk,
      });
      const uri = this.baseUrl + "getprofile";

      this.postprofile(uri, toSubmit);
    },

    postit(uri, toSubmit) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      axios
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          this.statusResult = response.data[0].Result;
          this.statusResultMsg = response.data[0].ResultMsg;
          this.setAlert(this.statusResult);
          // if(this.statusResultMsg == 1) {
          // something
          // }
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },

    postprofile(uri, toSubmit) {
      const axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      axios
        // .get("http://jsonplaceholder.typicode.com/posts")
        // .get('http://localhost:3000/pilotlist')
        .post(uri, toSubmit, axiosConfig)
        .then((response) => {
          // JSON responses are automatically parsed.
          this.profile = response.data;
          this.pid = response.data[0].RegId;
          this.fullname = response.data[0].FullName;
          this.curac = response.data[0].AC;
          this.curemail = response.data[0].Email;
          this.curmobile = response.data[0].Mobile;
          this.curmobile2 = response.data[0].Mobile2;
          this.curmobile2description = response.data[0].Mobile2Description;
          this.activationMsg = response.data[0].ActivationMsg;
          this.notifyenabled = response.data[0].NotifyEnabled;
          this.post.text = response.data[0].CountryCode;
          // this.post.text = this.valueInComponent;
        })
        .catch((e) => {
          this.errors.push(e);
        });
    },
    // IKKE NØDVENDIG HER
    // setNationCode() {
    //   this.post.id = 1;
    //   this.post.text = this.valueInComponent;
    // },
    setValueMethodInView(value) {
      this.valueInComponent = value;
      this.isValidNewNation = true;
    },
    setAlert(statusResult) {
      if (statusResult === 1) {
        this.isAlertVisible = true;
        this.isWarningAlertVisible = false;
      }
      if (statusResult === 0) {
        this.isWarningAlertVisible = true;
        this.isAlertVisible = false;
      }
    },
    showInfo(info) {
      this.isInfoVisible = true;
      this.info = info;
    },
  },
  components: {
    NotificationServiceHelp,
    Flags: () => import("@/components/Admin/Flags.vue"),
  },
};
</script>

    